// Editable fields from the supplied Lookup Controller contract.
const fields = [
    {
        "name": "name",
        "label": "Name",
        "type": "text",
        "required": true
    },
    {
        "name": "abbreviation",
        "label": "Abbreviation",
        "type": "text",
        "required": true
    },
    {
        "name": "commodityId",
        "label": "Commodity",
        "type": "lookup-select",
        "source": "commodities",
        "idType": "guid",
        "clearFields": ["baseUoMId", "baseUoMName"],
        "labelField": "commodityName",
        "resolveById": true,
        "required": true
    },
    {
        "name": "dimensionId",
        "label": "Dimension",
        "type": "lookup-select",
        "source": "dimensions",
        "idType": "guid",
        "clearFields": ["baseUoMId", "baseUoMName"],
        "labelField": "dimensionName",
        "resolveById": true,
        "required": true
    },
    {
        "name": "baseUoMId",
        "label": "Base UOM",
        "type": "lookup-select",
        "source": "units-of-measurement",
        "idType": "guid",
        "filterByCommodityAndDimension": true,
        "labelField": "baseUoMName",
        "resolveById": true,
        "required": true
    },
    {
        "name": "baseUoMConversion",
        "label": "Base UOM conversion",
        "type": "number",
        "required": true
    },
    {
        "name": "isActive",
        "label": "Active",
        "type": "checkbox",
        "hidden": true,
        "defaultValue": true,
        "required": false
    },
    { "name": "commodityName", "type": "hidden", "displayOnly": true },
    { "name": "dimensionName", "type": "hidden", "displayOnly": true },
    { "name": "baseUoMName", "type": "hidden", "displayOnly": true }
];

export default fields;
